const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;
const ADMIN_TOKEN_KEY = "tex_admin_token";

function authHeaders() {
  const token = typeof window !== "undefined" ? localStorage.getItem(ADMIN_TOKEN_KEY) : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function get(path, { auth = false } = {}) {
  const headers = auth ? authHeaders() : {};
  const res = await fetch(`${API}${path}`, { headers });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.detail || `Request to ${path} failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

async function post(path, body, { auth = false } = {}) {
  const headers = { "Content-Type": "application/json", ...(auth ? authHeaders() : {}) };
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.detail?.[0]?.msg || data.detail || `Request to ${path} failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export function saveAdminToken(token) {
  if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
  else localStorage.removeItem(ADMIN_TOKEN_KEY);
}

export function getAdminToken() {
  return localStorage.getItem(ADMIN_TOKEN_KEY);
}

export const api = {
  getCompany: () => get("/company"),
  getSiteContent: () => get("/site-content"),
  getTeam: () => get("/team"),
  getCoverage: () => get("/coverage"),
  lookupPincode: (code) => get(`/coverage/pincode/${encodeURIComponent(code)}`),
  getFaqs: () => get("/faqs"),
  submitContact: (payload) => post("/contact", payload),
  submitQuote: (payload) => post("/quote-requests", payload),
  listChemicals: () => get("/chemicals"),
  getChemical: (key) => get(`/chemicals/${key}`),
  getFirstAid: (key, route) => get(`/chemicals/${key}/first-aid/${route}`),
  getFlushDuration: (key, route) => get(`/chemicals/${key}/first-aid/${route}/duration`),
  getGhs: (key) => get(`/chemicals/${key}/ghs`),
  getPpe: (key, task) => get(`/chemicals/${key}/ppe/${task}`),
  getSpill: (size) => get(`/spill/${size}`),
  getSpillPlan: (volumeL) => get(`/spill-plan?volume_l=${encodeURIComponent(volumeL)}`),
  getCompatibility: () => get("/compatibility"),
  checkCompatibility: (mat, chem, tempC) => {
    const params = new URLSearchParams({ mat, chem });
    if (tempC !== undefined && tempC !== null && tempC !== "") params.set("temp_c", tempC);
    return get(`/compatibility/check?${params.toString()}`);
  },
  getSds: () => get("/sds"),
  getCoa: (batch) => get(`/coa/${encodeURIComponent(batch)}`),
  listCoa: (grade) => get(`/coa${grade ? `?grade=${encodeURIComponent(grade)}` : ""}`),
  getStandards: () => get("/standards"),
  identifyByPictograms: (pictograms) => post("/identify", { pictograms }),
  logIncident: (payload) => post("/incident-logs", payload),
  // ---- Admin ----
  login: (email, password) => post("/auth/login", { email, password }),
  me: () => get("/auth/me", { auth: true }),
  adminQuotes: () => get("/quote-requests", { auth: true }),
  adminContacts: () => get("/contact", { auth: true }),
  adminIncidents: () => get("/incident-logs", { auth: true }),
};
